import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { Router, NavigationEnd } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  secretKey = "qubeappsPro_token";
  private userSubject = new Subject<any>();
  private userDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private customerDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable();
  private currentUser: any;
  private dataSubject = new Subject<any>();
  data: any;
  private closeModalSubject = new Subject<void>();
  private addMode: boolean = true;
  private ProfiledataSubject = new Subject<boolean>();
  private _rerun = new BehaviorSubject<boolean>(false);
  rerun$ = this._rerun.asObservable();

  private reloadTrigger = new BehaviorSubject<boolean>(false);
  reloadTrigger$ = this.reloadTrigger.asObservable();

  
  
  GetpermissionNames:any;

  constructor(private spinner: NgxSpinnerService,private router: Router, private permissionService: PermissionService) {

  }

  triggerReload() {
    this.reloadTrigger.next(true);
  }

  triggerRerun() {
    this._rerun.next(true);
  }

  decryptAction(data:any)
  {
    const decryptedData = JSON.parse(CryptoJS.AES.decrypt(data, this.secretKey).toString(CryptoJS.enc.Utf8));
    return decryptedData;;
  }
  
  setTovalidateProfile(data: boolean) {
    this.ProfiledataSubject.next(data);
  }

  getTovalidateProfile(): Observable<boolean> {
    return this.ProfiledataSubject.asObservable();
  }

  closeModal(): void {
    this.closeModalSubject.next();
  }

  onModalClosed(): Observable<void> {
    return this.closeModalSubject.asObservable();
  }

  setData(data: any) {
    this.data = data;
    this.dataSubject.next(data);
  }

  getData(): any {
    return this.data;
  }

  showSpinner() {
    this.spinner.show();
  }

  hideSpinner() {
    this.spinner.hide();
  }

  setAddMode(addMode: boolean) {
    this.addMode = addMode;
  }

  getAddMode() {
    return this.addMode;
  }

  setUserData(data: any) {
    this.userDetails.next(data);
  }

  // Get the stored API result
  getUserData(): Observable<any> {
    return this.userDetails.asObservable();
  }

  setCustomerData(data: any) {
    this.customerDetails.next(data);
  }

  // Get the stored API result
  getCustomerData(): Observable<any> {
    return this.customerDetails.asObservable();
  }

  clearUserData() {
    this.userDetails.next(null); // Clear the data by passing null or an appropriate value
  }

  clearCustomerData() {
    this.customerDetails.next(null); // Clear the data by passing null or an appropriate value
  }

  async initPermission(){
    let permissionNamesString = localStorage.getItem('pr');
    permissionNamesString = this.decryptAction(permissionNamesString);
    
    if (permissionNamesString !== null) {
      this.GetpermissionNames = permissionNamesString
    } else {
      this.GetpermissionNames = [];
    }

    for (const permissionName of this.GetpermissionNames) {
      await this.permissionService.setPermission(permissionName, true);
    }
  }
}
